import { Component } from "react";
import classnames from "classnames";
import { MdRotateLeft, MdFilterList } from "react-icons/md";
import { withTranslation } from "react-i18next";
import { SearchInput } from "../../fields/base/TextField";
import { PaginationWidget } from "../../table/Pagination";
import { functionalUpdate } from "@tanstack/react-table";
import { CustomTriggerTooltip } from "../../core/basic/Tooltip";

class ReactTablePagination extends Component {
  getSafePage = (page) => {
    if (Number.isNaN(page)) {
      page = this.props.page;
    }
    return Math.min(Math.max(page, 0), this.props.pages - 1);
  };

  changePage = (nextPage) => {
    nextPage = functionalUpdate(nextPage, this.props.page);
    nextPage = this.getSafePage(nextPage);
    this.props.onPageChange(nextPage);
  };

  resetFilters = () => {
    const table = document.querySelector(".ReactTable");
    const filterRow = table?.querySelector(".-filters");
    const dropdownFilters = filterRow?.querySelectorAll("select");
    const inputFilters = filterRow?.querySelectorAll("input[type=text]");

    this.props.updateSearch("");

    if (this.props.setSortState) {
      this.props.setSortState();
    }

    if (inputFilters) {
      inputFilters.forEach((filter) => {
        filter.value = "";
      });
    }
    if (dropdownFilters) {
      dropdownFilters.forEach((filter) => {
        filter.selectedIndex = 0;
        filter.value = "all";
      });
    }
  };

  toggleFilter = () => {
    this.props.setShowFilters(!this.props.showFilters);
  };

  render() {
    const rowCount = this.props.data.length;

    const {
      // Computed
      pages,
      // Props
      page,
      pageSize,
      onPageSizeChange,
      className,
      t,
    } = this.props;

    return (
      <div className={classnames(className, "-pagination")} style={this.props.style}>
        <div className="filter-controls">
          <CustomTriggerTooltip toolTip={t(($) => $.merchandising["Show/hide table filters"])}>
            <button
              className="btn-toggle-filters"
              style={{
                background: "#fff",
                color: "#000",
                fontSize: "2rem",
                padding: "1rem",
                position: "relative",
              }}
              onClick={(e) => {
                this.toggleFilter(e);
              }}
            >
              <MdFilterList className="icon" style={{ fontSize: "24px", fontWeight: "bold" }} />
            </button>
          </CustomTriggerTooltip>
          <CustomTriggerTooltip toolTip={t(($) => $.merchandising["Reset table filters"])}>
            <button
              className="btn-reset-filters "
              style={{
                background: "#fff",
                color: "#000",
                fontSize: "2rem",
                padding: "1rem",
                position: "relative",
              }}
              onClick={() => {
                this.resetFilters();
                this.props.clearFilters();
              }}
            >
              <MdRotateLeft style={{ fontSize: "24px", fontWeight: "bold" }} />
            </button>
          </CustomTriggerTooltip>
          <SearchInput
            aria-label={t(($) => $.merchandising["Search brands"])}
            placeholder={t(($) => $.merchandising["Search"])}
            autoFocus
            value={this.props.searchTerm}
            onChange={(value) => {
              this.props.updateSearch(value);

              if (value.trim().length < 1) {
                this.props.clearSearchTermFilters();
              }
            }}
          />
        </div>

        {rowCount > 10 && (
          <PaginationWidget
            hideResultsCount
            currentPage={page}
            setCurrentPage={this.changePage}
            pageSize={pageSize}
            setPageSize={onPageSizeChange}
            totalPages={pages}
          />
        )}
      </div>
    );
  }
}

export default withTranslation(["merchandising"])(ReactTablePagination);
